import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
`;

export const ErrorContainer = styled.div`
  color: #d32f2f;
  padding: 10px;
  border: 1px solid #d32f2f;
  border-radius: 4px;
  margin-bottom: 10px;
  background-color: #ffebee;
`;

export const InfoBox = styled.div`
  padding: 10px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 20px;
`;

export const InfoParagraph = styled.p`
  margin: 0 0 8px 0;
  line-height: 1.5;
  color: #333;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Section = styled.div`
  margin-bottom: 20px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const ButtonContainer = styled.div`
  max-width: 300px;
`;

export const Code = styled.code`
  ${({ theme }) => `
    background-color: ${theme.tokens.color.background.secondary};
    padding: 2px 4px;
    border-radius: ${theme.tokens.border.radius.sm}px;
    font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', monospace;
    font-size: ${theme.tokens.fonts.size["0750"]}px;
  `}
`;
